import React, { useState, useEffect } from 'react';
import MobileProfile from './MobileProfile';
import DesktopProfile from './DesktopProfile';

const CustomerProfile = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1024);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return isMobile ? <MobileProfile /> : <DesktopProfile />;
};

export default CustomerProfile;
